import { graphql } from "../../graphql";

export const AllSourcesForProductsQuery = graphql(`
  query AllSourcesForProducts($products: [uuid!]!, $month: date!) {
    global_instrument(where: { global_product: { _in: $products }, month: { _eq: $month } }) {
      id
      month
      value
      edited_at
      edited_by
      globalProductByGlobalProduct {
        id
        globalPackageByGlobalPackage {
          source
        }
      }
    }
  }
`);

export const ProductInfoFragment = graphql(`
  fragment ProductInfoFragment on product {
    id
    artis_type
		curve_type
    code
    commodity_group
    description
    eod_product_dep
    geographical_region
    has_shared_cell
    logical_code
    maturity
    name
    package
    product_type
    summary_type
    uom
		dp
    product_uom {
      value
      description
    }
    packageByPackage {
      package_type
      name
      permissions(limit: 1, where: { folio_user: { _eq: $folioUser } }) {
        permission
        folio_user
      }
      sourceBySource {
        id
        name
        alias
        logo
        source_type
        exchange {
          code
        }
      }
    }
    commodityGroupByCommodityGroup {
      parent
      commodity_group: value
      commodity_parent_group {
        commodity_parent_group: value
      }
    }
    geographicalRegionByGeographicalRegion {
      geographical_region: value
    }
    product_global_dependencies {
      global_product
    }
  }
`);

export const ConfigsQuery = graphql(`
  query ConfigsQuery($maxRelMonth: Int!) {
    product_config(
      order_by: { relative_month: asc },
      where: {
          relative_month: { _lt: $maxRelMonth, _gte: 0 }
      }
    ) {
      formula
      product
      offset: relative_month
    }
  }
`);

export const ConfigsSub = graphql(`
  subscription ConfigsSub($maxRelMonth: Int!) {
    product_config(
      order_by: { relative_month: asc },
      where: {
          relative_month: { _lt: $maxRelMonth, _gte: 0 }
      }
    ) {
      formula
      product
      offset: relative_month
    }
  }
`);

export const ProductInfoQuery = graphql(`
  query ProductInfo($folioUser: String!) {
    product {
      ...ProductInfoFragment
    }
  }
`);

export const ProductInfoSub = graphql(`
  subscription ProductInfoSub($folioUser: String!) {
    product {
      ...ProductInfoFragment
    }
  }
`);

export const GridProductsByIds = graphql(`
  query GridProductsByIds($ids: [uuid!]!, $folioUser: String!) {
    product(where: { id: { _in: $ids } }) {
      ...ProductInfoFragment
    }
  }
`);

export const PackageFolderAccessQuery = graphql(`
  query PackageFolderAccess($packageId: Int!, $folioUser: String!) {
    package_by_pk(id: $packageId) {
      id
      name
      permissions(limit: 1, where: { folio_user: { _eq: $folioUser } }) {
        permission
      }
    }
  }
`);

export const GlobalProductInfoFragment = graphql(`
  fragment GlobalProductInfoFragment on global_product {
    __typename
    id
    name
    description
    uom
    geographical_region
    commodity_group
    global_package
    globalPackageByGlobalPackage {
      id
      name
      source
      description
      package_type
      sourceBySource {
        id
        name
        alias
        logo
        source_type
      }
      global_permissions(
        limit: 1
        where: { folio_user: { _eq: $folioUser } }
      ) {
        permission
        folio_user
      }
    }
  }
`);

export const GlobalProductsForLiveCharts = graphql(`
  query GlobalProductsForLiveCharts($folioUser: String!) {
    global_product {
      ...GlobalProductInfoFragment
    }
  }
`);

export const GlobalPackagesByProductIds = graphql(`
  query GlobalPackagesByProductIds($productIds: [uuid!]!) {
    global_package(where: { global_products: { id: { _in: $productIds } } }) {
      id
      source
      description
    }
  }
`);

export const GlobalProductsByProductsIds = graphql(`
  query GlobalProductsByProductsIds($productIds: [uuid!]!) {
    global_product(where: { id: { _in: $productIds } }) {
      id
      global_package
    }
  }
`);

export const PackagesFragment = graphql(`
	fragment PackagesFragment on package {
		id
		name
		source
		package_type
		dp
	}
`);

export const PackagesDpQuery = graphql(`
	query PackagesDpQuery {
		package {
			id
			dp
		}
	}
`);

export const ProductUserSettingsFragment = graphql(`
	fragment ProductUserSettingsFragment on product_user_settings {
		user_id
		product_id
		dp
	}
`);

export const ProductUserSettingsByUserIdQuery = graphql(`
	query ProductUserSettingsByUserId($userId: String!) {
		product_user_settings(where: { user_id: { _eq: $userId } }) {
			...ProductUserSettingsFragment
		}
	}
`);

export const UpsertProductUserSettingsMutation = graphql(`
	mutation UpsertProductUserSettings(
		$productId: uuid!
		$userId: String!
		$dp: Int
	) {
		insert_product_user_settings(
			objects: [
				{
					product_id: $productId
					user_id: $userId
					dp: $dp
				}
			]
			on_conflict: {
				constraint: product_user_settings_pkey
				update_columns: dp
			}
		) {
			returning {
				product_id
				user_id
				dp
			}
		}
	}
`);
